<template>
  <div>
    <v-layout row wrap>
      <v-flex d-flex xs6 md4 lg3 v-for="puzzleProduct in localPuzzleProducts" :key="puzzleProduct.id" class="pa-2">
        <v-card  class="flex-grow-1 " :to="hasReviewsFeature ? { name: 'puzzle', params: {puzzle_product_id: puzzleProduct.id} } : undefined" >
          <v-img
              :lazy-src="puzzleProduct.attributes.extraSmallImageSrc"
              :src="puzzleProduct.attributes.mediumImageSrc"
              class="white--text align-end "
              aspect-ratio="1"
          >
          </v-img>
          <v-card-subtitle v-if="hasReviewsFeature" class="card-subtitle">
            <span v-if="puzzleProduct.attributes.outOfStock">Out of Stock<br/></span>

            <div class="d-flex align-center">
              <h3><b>{{puzzleProduct.attributes.name}}</b></h3>
              <div class="flex-grow-1"> </div>
              <v-card-actions class="bottom-actions pa-0">
                <v-btn icon @click.stop.prevent="addWishlist(puzzleProduct.id)" v-if="!isWishlist(puzzleProduct.id)">
                  <v-icon>mdi-heart-outline</v-icon>
                </v-btn>
                <v-btn icon @click.stop.prevent="removeWishlist(puzzleProduct.id)" v-if="isWishlist(puzzleProduct.id)">
                  <v-icon color="red">mdi-heart</v-icon>
                </v-btn>
              </v-card-actions>
            </div>
            <div>by {{getBrandName(puzzleProduct.attributes.brandId)}}</div>
            <div class="d-flex flex-row align-center flex-wrap">
              <div class="d-flex">
                <div class="d-flex align-center">
                  <v-rating
                      color="yellow darken-1"
                      half-increments
                      length="1"
                      value="0"
                      dense
                      size="24"
                      readonly
                      :value="puzzleProduct.attributes.rating"
                  ></v-rating>
                  {{ puzzleProduct.attributes.rating }}
                </div>
              </div>
              <div class="flex-grow-1"></div>
              <themes :puzzle-product-id="puzzleProduct.id"></themes>
              <div class="theme pieces">{{puzzleProduct.attributes.pieceCount}} pieces</div>
            </div>
            <div class="d-flex flex-row align-center mt-2">
              <div>Dimensions:</div>
              <div class="flex-grow-1"></div>
              <div>{{puzzleProduct.attributes.length}}"x{{puzzleProduct.attributes.width}}"</div>
            </div>
            <div class="d-flex flex-row align-center mt-1">
              <div>Piece Type:</div>
              <div class="flex-grow-1"></div>
              <div> {{puzzleProduct.attributes.isLargeSized ? 'Large' : 'Standard'}}</div>
            </div>
            <ratings-sub-disiplay :puzzle-product="puzzleProduct"></ratings-sub-disiplay>


          </v-card-subtitle>
          <template v-if="!hasReviewsFeature">
            <v-card-subtitle class="legacy-card-subtitle">
              <span v-if="puzzleProduct.attributes.outOfStock">Out of Stock<br/></span>

              <b>Name:</b>  {{puzzleProduct.attributes.name}}<br/>
              <b>Brand:</b> {{getBrandName(puzzleProduct.attributes.brandId)}}<br/>
              <b>Piece Count:</b> {{puzzleProduct.attributes.pieceCount}}<br/>
              <b>Dimensions:</b> {{puzzleProduct.attributes.length}}"x{{puzzleProduct.attributes.width}}"<br/>
              <b>Piece Type:</b>  {{puzzleProduct.attributes.isLargeSized ? 'Large' : 'Standard'}}<br/>
              <themes :puzzle-product-id="puzzleProduct.id"></themes>
            </v-card-subtitle>
            <v-card-actions class="legacy-bottom-actions">
              <v-btn icon @click="addWishlist(puzzleProduct.id)" v-if="!isWishlist(puzzleProduct.id)">
                <v-icon>mdi-heart-outline</v-icon>
              </v-btn>
              <v-btn icon @click="removeWishlist(puzzleProduct.id)" v-if="isWishlist(puzzleProduct.id)">
                <v-icon color="red">mdi-heart</v-icon>
              </v-btn>
            </v-card-actions>
          </template>
        </v-card>
      </v-flex>
    </v-layout>
    <v-layout flex justify-center >
        <v-btn  class="success mt-16" v-show="totalAmount > totalShown" @click="showMore">Show More</v-btn>
    </v-layout>
  </div>
</template>

<script>
import {mapState} from "vuex";
import {mapGetters} from "vuex";
import ratingsSubDisiplay from "./ratings_sub_display";
import themes from "./themes.vue"


export default {
  name: 'wishlist_list',
  components: {
    ratingsSubDisiplay,
    themes
  },
  methods: {
    addWishlist(id) {
      this.$store.dispatch("addWishlist",id);
      this.localWishlistProductIds.push(parseInt(id));
    },
    removeWishlist(id) {
      this.$store.dispatch("removeWishlist",id);
      this.localWishlistProductIds.splice(this.localWishlistProductIds.indexOf(parseInt(id)),1);
    },
    isWishlist: function(id){
      return (this.localWishlistProductIds.indexOf(parseInt(id)) > -1);
    },
    getBrandName: function(brandId) {
      return this.brands[brandId].attributes.name;
    },
    onPuzzleProductsUpdated: function(){
      this.localPuzzleProducts = this.puzzleProducts.slice(0,this.showAmount);
      this.totalAmount = this.puzzleProducts.length;
      this.totalShown = this.showAmount;
    },
    showMore: function(){
      this.localPuzzleProducts.push(...this.puzzleProducts.slice(this.totalShown,this.totalShown + this.showAmount));
      this.totalShown = this.totalShown + this.showAmount;
    }
  },
  created: function(){
  },
  mounted: function(){
  },
  computed: {
    ...mapState({
    }),
    ...mapGetters({
      brands: 'getBrands',
      themesByProduct: 'getPuzzleProductThemesByProduct',
      themes: 'getThemes',
      hasReviewsFeature: 'hasReviewsFeature'
    })
  },
  data: function(){
    return {
      totalShown: 48,
      totalAmount: 0,
      showAmount: 48,
      localPuzzleProducts: []
    }
  },
  watch: {
    // call again the method if the route changes
    'puzzleProducts': 'onPuzzleProductsUpdated',
  },
  props: ['puzzleProducts','localWishlistProductIds']
}
</script>
<style scoped>
.title-bg {
  background-color: rgba(0,0,0,0.2);
}
.legacy-card-subtitle {
  margin-bottom: 52px;
}
.legacy-bottom-actions {
  position: absolute;
  bottom: 0;
}
</style>
<style>
.pieces {
  color: #3898ec;
  background-color: rgba(56, 152, 236, 0.1);
  margin-right: 0px !important;
}





</style>
